import { useNavigate, useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "../../home/fleet/monthlyReports/sharedInterface";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { mileageGapReportFileExportForDepartmentUserAsync } from "../../home/fleet/fleetSlice";
import { useEffect } from "react";

export const MonthlyReportsTab = () => {
  const params = useParams();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1];
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);

  useEffect(() => {
    if (
      params.tab === "monthly_reports" &&
      department &&
      !department.hasAdvancedAnalytics
    ) {
      navigate(`/${firstPath}`);
    }
  }, [params.tab, department, navigate, firstPath]);

  const handleDownloadReportFile = (reportFileUuid: string) => {
    if (!department) return;

    void dispatch(
      mileageGapReportFileExportForDepartmentUserAsync({
        reportFileUuid,
        departmentUuid: department.uuid,
      }),
    );
  };

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports
      canGenerateReports={false}
      downloadReportFileAction={handleDownloadReportFile}
    />
  );
};
